import React from 'react';
import { Button, KIND } from 'baseui/button';

import Accordian from 'commons-ui/src/components/keyValueView/Accordian';
import copy from 'commons-ui/src/assets/misc/copy.png';
import { DataList, Loader } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';

import { columnConfigs } from './listConfig';
import useStyles from './useStyles';
import useService from './useService';
import { AnalyzeCollusionProps } from '../types';

const AnalyzeCollusion: React.FC<AnalyzeCollusionProps> = (props) => {
	const {
		analyzeCollusionIsCollapsed,
		setAnalyzeCollusionIsCollapsed,
		dataFetchComplete,
		showLoader,
		copyToClipboard,
		handleDatalistFetchData
	} = useService(props);
	const classes = useStyles();

	const analyzeCollusionLabel = (
		<div className={classes.labelWithFilter}>
			<div className={classes.labelText}>Analyze Collusion</div>
			<div title='click to copy'>
				<Button kind={KIND.secondary} onClick={copyToClipboard}>
					<img className={classes.copyImage} src={copy} alt='' />
				</Button>
			</div>
		</div>
	);

	return (
		<>
			{showLoader && <Loader />}
			<Accordian
				label={analyzeCollusionLabel}
				panelKey='unnamedPanel'
				isCollapsed={analyzeCollusionIsCollapsed}
				setIsCollapsed={setAnalyzeCollusionIsCollapsed}>
				{dataFetchComplete && (
					<DataList
						fetchData={handleDatalistFetchData}
						columnConfigs={columnConfigs}
						hideActions
						entity={LIST_ENTITY_NAMES.ANALYZE_COLLUSION}
						filterable={false}
						searchable={false}
					/>
				)}
			</Accordian>
		</>
	);
};

export default AnalyzeCollusion;
